import { addTextField } from 'views/report/utils/add-text-field/add-text-field.ts';
import { TCoordinates } from 'views/report/types.ts';
import { TAddTextOptions } from 'views/report/utils/add-text-fields/types.ts';
import { fontBold, fontSecondarySize } from 'views/report/utils/style-consts.ts';

export const addTextFields = (doc: any, options: TAddTextOptions) => {
  const { x, y, title } = options;
  let sectionY = y;

  if (title) {
    doc.setFont(fontBold.fontName, fontBold.fontStyle);
    doc.setFontSize(fontSecondarySize);
    doc.text(title, x, y);
    sectionY += 9;
  }

  return (fields: any): TCoordinates => {
    fields.forEach(({ name, value }: any) => {
      addTextField(doc, { name, value, x, y: sectionY });
      sectionY += 6;
    });
    return { x, y: sectionY };
  };
};
